import React from "react";

import { Grid, GridCol } from "../../../../components/Grid";
import { Card } from "../../components/Card";
// components
import { Layout, Row } from "../../components/Layout";

// Config
import Config from "../../Config";
import CalendarFactorsHeatmap from "./Cards/CalendarFactorsHeatmap";
import FactorComparison from "./Cards/FactorComparison";
import SatisfactionFactors from "./Cards/SatisfactionFactors";

const Factors = () => {
	// render
	return (
		// topAreaMaxHeight is the height of the top area of the layout that gets the grey background
		<Layout title="Factors" topAreaMaxHeight={448}>
			<Row height={Config.FACTORS.ROW_HEIGHTS[0]}>
				<Grid gap={2} cols={12} padding={0}>
					<GridCol span={7}>
						<Card height={Config.FACTORS.ROW_HEIGHTS[0]}>
							<FactorComparison />
						</Card>
					</GridCol>
					<GridCol span={5}>
						<Card height={Config.FACTORS.ROW_HEIGHTS[0]}>
							<SatisfactionFactors />
						</Card>
					</GridCol>
				</Grid>
			</Row>
			<Row height={Config.FACTORS.ROW_HEIGHTS[1]}></Row>
			<Row height={Config.FACTORS.ROW_HEIGHTS[2]}>
				<div>
					<Grid gap={2} cols={12} padding={0}>
						<GridCol span={12}>
							<Card minHeight={Config.FACTORS.ROW_HEIGHTS[2]} testId="satisfaction-factors-heatmap-card">
								<CalendarFactorsHeatmap />
							</Card>
						</GridCol>
					</Grid>
				</div>
				<Row height={56} />
			</Row>
		</Layout>
	);
};

export default Factors;
